export default __webpack_public_path__ + "static/media/e5.93b31b56.jpg";